import { useState } from "react";

import type { ColumnDef } from "@tanstack/react-table";

import { DataTableCenteredCell } from "@/shared/ui/DataTable";
import { AccountReassignModalPreRelease } from "@/widgets/AvailableAccountsModal/AccountReassignModalPreRelease";
import { SortButton } from "@/features/SortButton/SortButton";
import { HandleSelectDPUserButton } from "@/pages/restricted/shared/main-page/ui/head/HeadDashboardProDataTable";
import { Roles } from "@/entities/user";
import { Label } from "@/shared/ui/label";
import type { Manager } from "@/entities/manager";
import { useIsCurrentlyAtDashboardPro } from "@/shared/hooks";

export const ManagerColumns: ColumnDef<Manager>[] = [
  {
    accessorKey: "username",
    header: () => <SortButton sort="username" title="Никнейм" />,
    cell: function Cell({ row }) {
      const isCurrentlyAtDashboardPro = useIsCurrentlyAtDashboardPro([
        Roles.Head,
        Roles.MasterTeamLead,
        Roles.TeamLead,
      ]);

      const { userId } = row.original;
      if (!userId) return <Label className="px-4">Пользователь удален</Label>;

      return isCurrentlyAtDashboardPro ? (
        <HandleSelectDPUserButton
          userId={row.original.userId?._id ?? ""}
          userName={row.original.userId?.username ?? ""}
          userRole={Roles.Manager}
        />
      ) : (
        <div className="h-9 px-4 py-2">
          {row.original.userId?.username ?? "N/A"}
        </div>
      );
    },
  },
  {
    accessorKey: "curatorsCount",
    header: () => (
      <DataTableCenteredCell>
        <SortButton sort="curatorsCount" title="Аккаунты" />
      </DataTableCenteredCell>
    ),
    cell: ({ row }) => {
      return (
        <DataTableCenteredCell>
          {row.original.curatorsCount ?? row.original.curators.length}
        </DataTableCenteredCell>
      );
    },
  },
  {
    id: "actions",
    header: () => (
      <DataTableCenteredCell className="md:hidden">
        Действия
      </DataTableCenteredCell>
    ),
    cell: function Cell({ row }) {
      const { curators, userId } = row.original;
      const [isModalOpen, setIsModalOpen] = useState(false);

      if (!userId || !curators) return null;

      return (
        <DataTableCenteredCell>
          <AccountReassignModalPreRelease
            accounts={curators}
            managerId={userId?._id ?? ""}
            open={isModalOpen}
            onOpenChange={setIsModalOpen}
          />
        </DataTableCenteredCell>
      );
    },
  },
];
